import { render, staticRenderFns } from "./PreferenceChip.vue?vue&type=template&id=65cf828d&scoped=true&"
import script from "./PreferenceChip.vue?vue&type=script&lang=js&"
export * from "./PreferenceChip.vue?vue&type=script&lang=js&"
import style0 from "./PreferenceChip.vue?vue&type=style&index=0&id=65cf828d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf828d",
  null
  
)

export default component.exports